import laboratorySidebarStore from '@/modules/laboratoryModule/sideBar/laboratorySideBarStore'
import { laboratoryTasksService } from '@/modules/laboratoryModule/services/laboratoryTasksService'
import sidebarConfig from '@/modules/laboratoryModule/config/sidebarConfig'
import { merge, find, orderBy } from 'lodash'

export default {
    data() {
        return {
            tasks: [],
            summaryTasks: null
        }
    },
    methods: {
        async loadTasks(sectionIds) {
            this.tasks = []

            laboratoryTasksService.cancelTasksCall()
            if (sectionIds.length) {
                const response =
                    await this.$_toCallSecure(
                        laboratoryTasksService.getTasks(this.$store.getters.labId, sectionIds))
                if (response) {
                    response.forEach(task => {
                        const operation = find(sidebarConfig, { id: task.operation })
                        merge(task, operation)
                    })
                    this.tasks = orderBy(response, ['order'], ['asc'])
                }
            }

            laboratorySidebarStore.state.customOptions = this.tasks
        },
        async loadSummaryTasks(sectionIds) {
            laboratoryTasksService.cancelSummaryTasksCall()
            if (sectionIds.length) {
                const response =
                    await this.$_toCallSecure(
                        laboratoryTasksService.getSummaryTasks(this.$store.getters.labId, sectionIds))
                if (response) {
                    this.summaryTasks = Object.fromEntries(
                        response.map(summaryTask => [ summaryTask.operation, summaryTask.count ]))
                }
            }
        }
    }
}
